// @flow
type GeocoordType = { lat: number, lon: number };

function degreesToRadians(degrees: number) {
  return (degrees * Math.PI) / 180;
}

const EARTH_RADIUS_KM = 6731.0;
export const MAX_TERRESTIAL_DISTANCE = 2 * Math.PI * EARTH_RADIUS_KM;

export function getDistanceInKm(
  coord1: ?GeocoordType,
  coord2: ?GeocoordType
): number {
  if (!coord1 || !coord2) return 0;

  const latDifference = degreesToRadians(coord2.lat - coord1.lat);
  const lonDifference = degreesToRadians(coord2.lon - coord1.lon);

  const lat1Radians = degreesToRadians(coord1.lat);
  const lat2Radians = degreesToRadians(coord2.lat);

  const a =
    Math.sin(latDifference / 2) * Math.sin(latDifference / 2) +
    Math.sin(lonDifference / 2) *
      Math.sin(lonDifference / 2) *
      Math.cos(lat1Radians) *
      Math.cos(lat2Radians);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return EARTH_RADIUS_KM * c;
}

// logic credit of https://stackoverflow.com/a/365853/1413689
export function formatDistance(
  coord1: ?GeocoordType,
  coord2: ?GeocoordType
): string {
  const distanceInKm = getDistanceInKm(coord1, coord2);
  if (distanceInKm <= 0) return '';
  if (distanceInKm < 1.0) {
    return `${Math.floor(distanceInKm * 1000)}m`;
  }
  if (distanceInKm > 100) {
    return '>100km';
  }
  return `${Math.floor(distanceInKm)}km`;
}
